import React, { useContext } from "react";
import jimbo_store from "../../images/img_default.png";

// Función para oscurecer un color
const darkenColor = (color, amount = 0.5) => {
	// Eliminar el # si existe
	color = color.replace("#", "");

	// Convertir a valores RGB
	let r = parseInt(color.substring(0, 2), 16);
	let g = parseInt(color.substring(2, 4), 16);
	let b = parseInt(color.substring(4, 6), 16);

	// Oscurecer los valores RGB (multiplicar por un factor menor a 1)
	r = Math.floor(r * amount);
	g = Math.floor(g * amount);
	b = Math.floor(b * amount);

	// Asegurar que los valores estén en el rango correcto
	r = Math.max(0, Math.min(255, r));
	g = Math.max(0, Math.min(255, g));
	b = Math.max(0, Math.min(255, b));

	// Convertir de nuevo a formato hexadecimal
	return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
};

export const VisitasHistoria = ({infoCompany}) => {
	const API_URL = process.env.REACT_APP_API_URL;

	const historyData = infoCompany?.view3;
	const actualidadData = infoCompany?.view4;

	// Obtener el color del tema

	const darkThemeColor = 'var(--theme-visit)';

	// Crear una versión semitransparente del color oscuro para la superposición

	// Función para parsear texto con asteriscos (para el efecto de texto azul)
	const parseTextWithAsterisks = (text) => {
		const parts = text.split(/(\*.*?\*)/);
		return parts.map((part, i) => {
			if (/^\*.*\*$/.test(part)) {
				return (
					<span key={i} style={{ color: "var(--theme-visit)", fontWeight: 800 }}>
						{part.slice(1, -1)}
					</span>
				);
			}
			return <React.Fragment key={i}>{part}</React.Fragment>;
		});
	};

	return (
		<div>
			{/* Nuestra Historia */}
			<div className="historia-section">
				<div className="dots-1"></div>
				<div className="doughnut-1"></div>
				<div className="doughnut-2"></div>
				<div
					className="historia-content"
					style={{
						background: darkThemeColor,
						position: "relative",
					}}>
					{/* Capa de overlay para oscurecer aún más */}
					<div
						style={{
							position: "absolute",
							top: 0,
							left: 0,
							width: "100%",
							height: "100%",
							backgroundColor: "rgba(0, 0, 0, 0.7)", // Overlay negro semitransparente
							zIndex: 1,
						}}></div>

					{/* Contenido Desktop (se oculta en móvil) */}
					<div className="text-content" style={{ position: "relative", zIndex: 2 }}>
						<div className="title-stack">
							<h1 className="historia-title">
								{parseTextWithAsterisks(historyData?.title || "Nuestra Historia")}
							</h1>
						</div>
						<p className="historia-description">
							{historyData?.text ||
								`Desde nuestros humildes comienzos en 2020 en la vibrante ciudad de
              Santa Cruz hemos recorrido un largo camino. Lo que empezó como una
              pequeña empresa legalmente establecida se ha transformado en un ser
              un referente, siempre comprometido con la calidad y la satisfacción del
              cliente. Nuestra historia de la empresa o tienda Jhimbo es testimonio de
              nuestra dedicación y pasión por traer lo mejor a nuestros clientes.`}
						</p>
					</div>

					{/* Contenedor del título para móvil (se muestra solo en móvil) */}
					<div className="mobile-title-container" style={{ position: "relative", zIndex: 2 }}>
						<h1 className="historia-title">
							{parseTextWithAsterisks(historyData?.title || "Nuestra Historia")}
						</h1>
					</div>

					{/* Imagen */}
					<div className="image-container-trap-right" style={{ position: "relative", zIndex: 2 }}>
						<div className="trapezoid-image-right">
							<img
								src={historyData?.img_url ? `${API_URL}${historyData.img_url}` : jimbo_store}
								alt="Jhimbo store front"
								className="store-image"
							/>
						</div>
					</div>

					{/* Contenedor de descripción para móvil (se muestra solo en móvil) */}
					<div className="mobile-description-container" style={{ position: "relative", zIndex: 2 }}>
						<p className="historia-description">
							{historyData?.text ||
								`Desde nuestros humildes comienzos en 2020 en la vibrante ciudad de
              Santa Cruz hemos recorrido un largo camino. Lo que empezó como una
              pequeña empresa legalmente establecida se ha transformado en un ser
              un referente, siempre comprometido con la calidad y la satisfacción del
              cliente. Nuestra historia de la empresa o tienda Jhimbo es testimonio de
              nuestra dedicación y pasión por traer lo mejor a nuestros clientes.`}
						</p>
					</div>
				</div>
			</div>

			{/* Nuestra Actualidad */}
			<div className="actualidad-section">
				<div className="dots-1"></div>
				<div className="doughnut-1"></div>
				<div className="doughnut-2"></div>
				<div className="doughnut-3"></div>
				<div className="doughnut-4"></div>
				<div className="doughnut-5"></div>
				<div
					className="actualidad-content"
					style={{
						background: darkThemeColor,
						position: "relative",
					}}>
					{/* Capa de overlay para oscurecer aún más */}
					<div
						style={{
							position: "absolute",
							top: 0,
							left: 0,
							width: "100%",
							height: "100%",
							backgroundColor: "rgba(0, 0, 0, 0.7)", // Overlay negro semitransparente
							zIndex: 1,
						}}></div>

					{/* Contenido Desktop (se oculta en móvil) */}
					<div className="text-content" style={{ position: "relative", zIndex: 2 }}>
						<h2 className="actualidad-title">
							{parseTextWithAsterisks(actualidadData?.title || "Nuestra *Actualidad*")}
						</h2>
						<p className="description">
							{actualidadData?.text ||
								`Desde nuestros humildes comienzos en 2020 en la vibrante ciudad de
              Santa Cruz hemos recorrido un largo camino. Lo que empezó como una
              pequeña empresa legalmente establecida se ha transformado en un ser
              un referente, siempre comprometido con la calidad y la satisfacción del
              cliente. Nuestra historia de la empresa o tienda Jhimbo es testimonio de
              nuestra dedicación y pasión por traer lo mejor a nuestros clientes.`}
						</p>
					</div>

					{/* Contenedor del título para móvil (se muestra solo en móvil) */}
					<div className="mobile-title-container" style={{ position: "relative", zIndex: 2 }}>
						<h2 className="actualidad-title">
							{parseTextWithAsterisks(actualidadData?.title || "Nuestra *Actualidad*")}
						</h2>
					</div>

					{/* Imagen */}
					<div className="image-container-trap" style={{ position: "relative", zIndex: 2 }}>
						<div className="trapezoid-image">
							<img
								src={actualidadData?.img_url ? `${API_URL}${actualidadData.img_url}` : jimbo_store}
								alt="Jhimbo store front"
								className="store-image"
							/>
						</div>
					</div>

					{/* Contenedor de descripción para móvil (se muestra solo en móvil) */}
					<div className="mobile-description-container" style={{ position: "relative", zIndex: 2 }}>
						<p className="description">
							{actualidadData?.text ||
								`Desde nuestros humildes comienzos en 2020 en la vibrante ciudad de
              Santa Cruz hemos recorrido un largo camino. Lo que empezó como una
              pequeña empresa legalmente establecida se ha transformado en un ser
              un referente, siempre comprometido con la calidad y la satisfacción del
              cliente. Nuestra historia de la empresa o tienda Jhimbo es testimonio de
              nuestra dedicación y pasión por traer lo mejor a nuestros clientes.`}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};
